import { ResolveFn } from '@angular/router';
import { ApiService } from '../services/api.service';
import { ToasterService } from '../services/toaster.service';
import { catchError, EMPTY, map, tap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { UtilityService } from '../services/utility.service';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { NavigationService } from '../services/navigation.service';

export const orgDetailsResolver: ResolveFn<boolean> = (route, state) => {
  const orgId: string = route.params['orgId'].split('.html')[0];
  const apiService = inject(ApiService);
  const toasterService = inject(ToasterService);
  const utilityService = inject(UtilityService);
  const navigationService = inject(NavigationService)

  if (utilityService.isUserLoggedIn()) {
    const url = `${webRedirectionUrl.orgDetails}${orgId}`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.getOrganisationDetail(orgId).pipe(
      tap(() => {
        apiService.setOrgProfileVisitCount(orgId).subscribe();
      }),
      map((resp) => {
        return resp;
      }),
      catchError((e) => {
        toasterService.error('Organisation details not found');
        navigationService.handleResolverError(e);
        return EMPTY;
      }),
    );
  }
};
